<div class="flex-row" [ngClass]="item.alignment ? item.alignment : 'flex-top'" [appFlexColumnHeight]="item.fill_height">
      <div *ngFor="let list of item.content; let $index = index" [ngClass]="getFlexClass(list)">
        <div [ngClass]="{'right-transparent-gradient':list.gradient}">
            <div style="flex:1">
                <button *ngIf="list.collapsible" pButton (click)="list.is_hidden = !list.is_hidden"><i [ngClass]="list.icon" [title]="list.translation_key||list.title| translation|translationFromString | transformText :list?.text_transform" [style.color]="list.color"></i></button>
                <div *ngIf="!list.is_hidden">                  
                  <app-rendered [childview]="item.childview || childview" [paramprefix]="item.paramprefix" [info]="info" *ngFor="let it of list.content" [item]="it" [data]="data" [arr]="list.content" (deleteDataEvent)="delete($event)" (openViewEvent)="openView($event)" (moveHandler)="openMove()" (openLinkEvent)="openLink($event)"></app-rendered>
                </div>
            </div>
        </div>
    </div>
</div>
